import { SEQUENCE_TYPE_ID } from 'customer-data-filters-ui/constants/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import SequencesReferenceResolver from 'reference-resolvers/resolvers/SequencesReferenceResolver';
const Sequence = ObjectDefinitionRecord({
  enableAsAssociatedType: false,
  objectTypeId: SEQUENCE_TYPE_ID,
  getPropertyResolver: () => SequencesReferenceResolver,
  referenceObjectType: 'SEQUENCE_PROPERTIES'
});
export default Sequence;